import {
  InputOTP,
  InputOTPGroup,
  InputOTPSeparator,
  InputOTPSlot
} from '@/components/ui/input-otp'

import { isFieldInvalid } from '@/utils'

import { FieldWrapper } from './field-wrapper'
import { useFieldContext } from './form'

export type OTPProps = {
  autoFocus?: boolean
  className?: string
  containerClassName?: string
  label?: React.ReactNode
  maxLength?: number
  onComplete?: (value: string) => void
  required?: boolean
}

export const OTP = (props: OTPProps) => {
  const field = useFieldContext<string>()
  const isInvalid = isFieldInvalid(field)
  const {
    label,
    maxLength = 6,
    onComplete,
    required = false,
    ...restProps
  } = props

  return (
    <FieldWrapper field={field} label={label} required={required}>
      <InputOTP
        aria-invalid={isInvalid || undefined}
        data-invalid={isInvalid || undefined}
        id={field.name}
        maxLength={maxLength}
        onBlur={field.handleBlur}
        onChange={(value) => {
          field.handleChange(value)
          if (value.length === maxLength && onComplete) {
            onComplete(value)
          }
        }}
        value={field.state.value}
        {...restProps}
      >
        <InputOTPGroup>
          <InputOTPSlot index={0} />
          <InputOTPSlot index={1} />
          <InputOTPSlot index={2} />
        </InputOTPGroup>
        <InputOTPSeparator />
        <InputOTPGroup>
          <InputOTPSlot index={3} />
          <InputOTPSlot index={4} />
          <InputOTPSlot index={5} />
        </InputOTPGroup>
      </InputOTP>
    </FieldWrapper>
  )
}
